import { Component, computed, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Address, IWizardStepComponent } from '@mwe/models';
import { UiComponentsModule } from '@mwe/ui/components';
import { InfoCardComponent } from '@shared-ikp/components/cards/info-card/info-card.component';
import { CustomerRegistrationService } from '../../../service/customer-registration/customer-registration.service';
import { InfoInputReadOnlyComponent } from '@shared-ikp/components/inputs/info-input-read-only/info-input-read-only.component';
import { ROUTE_COMPANY_SELECT } from '../../../app.constants';
import { InfoCardType } from '@shared-ikp/model/info-card-type.enum';
import { getFormattedAddressPostCodeAndStreet } from '@mwe/utils';

@Component({
  selector: 'ikp-berater-company-check',
  templateUrl: './company_check.component.html',
  standalone: true,
  imports: [UiComponentsModule, InfoCardComponent, InfoInputReadOnlyComponent, RouterModule],
})
export class CompanyCheckComponent implements IWizardStepComponent {
  protected PARENT_ROUTE_COMPANY_SELECT = `../${ROUTE_COMPANY_SELECT}`;

  protected readonly InfoCardType = InfoCardType;

  registrationService = inject(CustomerRegistrationService);

  sortedCompanies = computed(() => {
    return this.registrationService.registrationModel().companies.sort((a, b) => a.name.localeCompare(b.name));
  });

  checkboxClicked(companyId: string): void {
    const company = this.registrationService.registrationModel().companies.find(c => c.gpNr === companyId);
    this.registrationService.toggleCompany(company);
  }

  validate(): boolean {
    // check if some companies are selected
    return this.registrationService.registrationModel().companies.length > 0;
  }

  hasAllNeededData(): boolean {
    return this.registrationService.registrationModel().companies.length > 0;
  }

  submit(): Promise<void> {
    return Promise.resolve(undefined);
  }

  getFormattedAddress(address: Address): string {
    return getFormattedAddressPostCodeAndStreet(address);
  }
}
